import { render, staticRenderFns } from "./DirectOrdersList.vue?vue&type=template&id=d8b02fe2&scoped=true"
import script from "./DirectOrdersList.vue?vue&type=script&lang=js"
export * from "./DirectOrdersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b02fe2",
  null
  
)

export default component.exports